import { ColorEnum } from '@/constants/color'
import { headerHeight } from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet } from 'react-native-unistyles'

interface SectionHeaderProps {
    children: string
    style?: StyleProp<ViewStyle>
}

const SectionHeader: FC<SectionHeaderProps> = ({ children, style }) => {
    return (
        <View style={[styles.container, style]}>
            <Typography.Menu size="small" numberOfLines={1} style={styles.section}>
                {children}
            </Typography.Menu>
            <View style={styles.divider} />
        </View>
    )
}

const styles = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        height: headerHeight,
        gap: 8,
    },
    section: {
        flexShrink: 0,
        textTransform: 'uppercase',
    },
    divider: {
        flex: 1,
        backgroundColor: ColorEnum.GRAY_300,
        height: 1,
    },
})

export default SectionHeader
